// Path: src\Components\CommonFields\TextInput.jsx
import React from 'react';
import TextField from '@mui/material/TextField';

const TextInput = ({ labelName, placeholder, value, onChange, error, helperText, readOnly = false, inputLength = 32, disabled = false }) => {
  return (
    <TextField
      id="outlined-required"
      label={labelName}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      disabled={disabled}
      inputProps={{
        maxLength: inputLength,
        readOnly: readOnly,
        sx: { borderRadius: 0 }
      }}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
      }}
    />
  );
};

export default TextInput;
